import React, { useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import Axios from 'axios';
import Sidebar from './SideBar';
import Swal from 'sweetalert2';
import config from './Componentes/config';
import useAuthRedirect from "./Componentes/auth";
import { registrarLog } from './Componentes/logService';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatearRutCompleto, formatearRut } from './Componentes/rutUtils';
import { getEmpresaByCodigo, getEmpresaById } from './Componentes/empresasConfig';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

const lookupEmpresa = (idOrCodigo) => {
    const e = getEmpresaById(idOrCodigo) || getEmpresaByCodigo(idOrCodigo);
    return { nombre: e.nombre, logoPDF: e.logoPDF };
};

function AsignacionInventario() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard];
    const idEmpresa = cookies.idEmpresa;
    const NombreEmpresa = cookies.NombreEmpresa;
    const userName = cookies.usuario;

    // Estados para el colapso del sidebar
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);

    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };

    // Estados principales
    const [trabajadores, setTrabajadores] = useState([]);
    const [trabajadorSeleccionado, setTrabajadorSeleccionado] = useState(null);
    const [tiposProducto, setTiposProducto] = useState([]);
    const [productos, setProductos] = useState([]);
    const [detalleInventario, setDetalleInventario] = useState([]);

    // Estados para navegación del catálogo
    const [vistaActual, setVistaActual] = useState("trabajadores"); // "trabajadores", "tipos", "productos", "items"
    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);

    // Estados para asignaciones
    const [itemsAsignados, setItemsAsignados] = useState([]);
    const [showExportModal, setShowExportModal] = useState(false);
    const [trabajadoresParaExportar, setTrabajadoresParaExportar] = useState([]);
    const [itemsParaExportar, setItemsParaExportar] = useState([]);

    // Estados para modal de detalle de items asignados
    const [showDetalleModal, setShowDetalleModal] = useState(false);
    const [itemsAsignadosDetalle, setItemsAsignadosDetalle] = useState([]);
    const [loadingDetalle, setLoadingDetalle] = useState(false);

    // Estados para modal de selección de items para PDF
    const [showSeleccionPDFModal, setShowSeleccionPDFModal] = useState(false);
    const [itemsSeleccionadosPDF, setItemsSeleccionadosPDF] = useState([]);
    const [tipoActa, setTipoActa] = useState("entrega"); // "entrega" o "reposicion"

    // Cargar datos iniciales
    useEffect(() => {
        cargarTrabajadores();
        cargarTiposProducto();
        cargarProductos();
        cargarDetalleInventario();
    }, [idEmpresa]);

    const cargarTrabajadores = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getTrabajadores`, {
                headers: { Authorization: `Bearer ${cookies.token}` },
                params: { id: idEmpresa, estado: 'Vigente' }
            });
            setTrabajadores(response.data);
        } catch (error) {
            console.error("Error al cargar trabajadores:", error);
        }
    };

    const cargarTiposProducto = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getTiposProducto`, {
                headers: { Authorization: `Bearer ${cookies.token}` }
            });
            setTiposProducto(response.data);
        } catch (error) {
            console.error("Error al cargar tipos de producto:", error);
        }
    };

    const cargarProductos = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getProductosInventario`, {
                headers: { Authorization: `Bearer ${cookies.token}` },
                params: { idEmpresa }
            });
            setProductos(response.data);
        } catch (error) {
            console.error("Error al cargar productos:", error);
        }
    };

    const cargarDetalleInventario = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getDetalleInventario`, {
                headers: { Authorization: `Bearer ${cookies.token}` },
                params: { idEmpresa }
            });
            setDetalleInventario(response.data);
        } catch (error) {
            console.error("Error al cargar detalle de inventario:", error);
        }
    };

    // Funciones de navegación
    const seleccionarTrabajador = (trabajador) => {
        // Prevenir selección cuando el modal de exportación está abierto
        if (showExportModal) {
            return;
        }

        setTrabajadorSeleccionado(trabajador);
        setVistaActual("tipos");
        setItemsAsignados([]);
        cargarAsignacionesActuales(trabajador.ID_Trabajador);
    };

    const cargarAsignacionesActuales = async (idTrabajador) => {
        try {
            const asignaciones = detalleInventario.filter(item =>
                item.ID_Trabajador_Asignado === idTrabajador
            );
            setItemsAsignados(asignaciones);
        } catch (error) {
            console.error("Error al cargar asignaciones:", error);
        }
    };

    // Función para cargar detalle completo de items asignados
    const cargarDetalleItemsAsignados = async (idTrabajador) => {
        setLoadingDetalle(true);
        try {
            const response = await Axios.get(`${config.API_URL}/getDetalleItemsAsignados`, {
                headers: { Authorization: `Bearer ${cookies.token}` },
                params: { idTrabajador }
            });
            setItemsAsignadosDetalle(response.data);
            setShowDetalleModal(true);
        } catch (error) {
            console.error("Error al cargar detalle de items asignados:", error);
            Swal.fire('Error', 'Error al cargar el detalle de items asignados', 'error');
        } finally {
            setLoadingDetalle(false);
        }
    };

    // Función para manejar click en "Items Asignados"
    const handleItemsAsignadosClick = () => {
        if (trabajadorSeleccionado && itemsAsignados.length > 0) {
            cargarDetalleItemsAsignados(trabajadorSeleccionado.ID_Trabajador);
        }
    };

    const navegarATipo = (tipo) => {
        setTipoSeleccionado(tipo);
        setVistaActual("productos");
    };

    const navegarAProducto = (producto) => {
        setProductoSeleccionado(producto);
        setVistaActual("items");
    };

    const volverAVista = (vista) => {
        setVistaActual(vista);
        if (vista === "trabajadores") {
            setTrabajadorSeleccionado(null);
            setTipoSeleccionado(null);
            setProductoSeleccionado(null);
            setItemsAsignados([]);
        } else if (vista === "tipos") {
            setTipoSeleccionado(null);
            setProductoSeleccionado(null);
        } else if (vista === "productos") {
            setProductoSeleccionado(null);
        }
    };

    // Funciones de filtrado
    const getProductosPorTipo = (idTipo) => {
        return productos.filter(producto => producto.ID_Tipo === idTipo);
    };

    const getItemsDisponiblesPorProducto = (idProducto) => {
        return detalleInventario.filter(item =>
            item.ID_Producto === idProducto &&
            item.Estado_Unidad === 'Disponible'
        );
    };

    // Funciones de asignación
    const asignarItem = async (item) => {
        try {
            const response = await Axios.put(`${config.API_URL}/asignarItemInventario`, {
                idDetalle: item.ID_Detalle,
                idTrabajador: trabajadorSeleccionado.ID_Trabajador,
                usuarioAsignacion: userName
            });

            if (response.data.success) {
                // Actualizar estados locales
                setItemsAsignados([...itemsAsignados, { ...item, ID_Trabajador_Asignado: trabajadorSeleccionado.ID_Trabajador }]);
                await cargarDetalleInventario(); // Recargar para actualizar disponibilidad

                // Registrar en log
                await registrarLog({
                    Usuario: userName,
                    Modulo: 'AsignacionInventario',
                    Detalle: `Item asignado: ${item.Codigo_Individual} (${item.Nombre_Producto}) a trabajador ${trabajadorSeleccionado.Nombres} ${trabajadorSeleccionado.Apellidos}`,
                    Estado: 'Éxito',
                });

                Swal.fire('Éxito', `Item ${item.Codigo_Individual} asignado correctamente`, 'success');
            }
        } catch (error) {
            console.error("Error al asignar item:", error);

            // Registrar error en log
            await registrarLog({
                Usuario: userName,
                Modulo: 'AsignacionInventario',
                Detalle: `Error al asignar item ${item.Codigo_Individual} - ${error.message}`,
                Estado: 'Error',
            });

            Swal.fire('Error', 'Error al asignar el item', 'error');
        }
    };

    const desasignarItem = async (item) => {
        // Mostrar alerta de confirmación con campos para estado y razón condicional
        const { value: formValues } = await Swal.fire({
            title: 'Confirmar Desasignación',
            html: `
                <div style="text-align: left; margin-bottom: 20px;">
                    <p><strong>Item:</strong> ${item.Codigo_Individual || 'Sin código'}</p>
                    <p><strong>Producto:</strong> ${item.Nombre_Producto}</p>
                    <p><strong>Trabajador:</strong> ${trabajadorSeleccionado?.Nombres} ${trabajadorSeleccionado?.Apellidos}</p>
                </div>
                <div style="margin-bottom: 15px;">
                    <label for="swal-estado" style="display: block; margin-bottom: 5px; font-weight: bold;">Nuevo Estado del Item:</label>
                    <select id="swal-estado" class="swal2-input" style="width: 100%;">
                        <option value="">Seleccione un estado</option>
                        <option value="Disponible">Disponible (para reasignación)</option>
                        <option value="En_Reparacion">En Reparación</option>
                        <option value="Dado_De_Baja">Dado de Baja</option>
                    </select>
                </div>
                <div id="razon-container" style="display: none;">
                    <label for="swal-razon" style="display: block; margin-bottom: 5px; font-weight: bold;">Razón de la Baja:</label>
                    <textarea id="swal-razon" class="swal2-textarea" placeholder="Ej: Pérdida, rotura, fin de vida útil, etc." style="width: 100%; min-height: 80px; padding: 10px; border: 1px solid #d1d3e2; border-radius: 0.35rem; font-size: 0.875rem; resize: vertical; box-sizing: border-box;"></textarea>
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Confirmar Desasignación',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545',
            didOpen: () => {
                // Configurar el evento onchange después de que el modal se abra
                const estadoSelect = document.getElementById('swal-estado');
                const razonContainer = document.getElementById('razon-container');
                const razonTextarea = document.getElementById('swal-razon');

                estadoSelect.addEventListener('change', function () {
                    if (this.value === 'Dado_De_Baja') {
                        razonContainer.style.display = 'block';
                    } else {
                        razonContainer.style.display = 'none';
                        razonTextarea.value = '';
                    }
                });
            },
            preConfirm: () => {
                const estado = document.getElementById('swal-estado').value;
                const razon = document.getElementById('swal-razon').value;

                if (!estado) {
                    Swal.showValidationMessage('Debe seleccionar un estado');
                    return false;
                }

                // Solo requerir razón si el estado es "Dado_De_Baja"
                if (estado === 'Dado_De_Baja' && !razon.trim()) {
                    Swal.showValidationMessage('Debe ingresar una razón para dar de baja el item');
                    return false;
                }

                return { estado, razon: razon.trim() || null };
            }
        });

        if (formValues) {
            try {
                const response = await Axios.put(`${config.API_URL}/desasignarItemInventario`, {
                    idDetalle: item.ID_Detalle,
                    nuevoEstado: formValues.estado,
                    razonDesasignacion: formValues.razon,
                    usuarioDesasignacion: userName
                });

                if (response.data.success) {
                    // Actualizar estados locales
                    setItemsAsignados(itemsAsignados.filter(asignado => asignado.ID_Detalle !== item.ID_Detalle));
                    await cargarDetalleInventario(); // Recargar para actualizar disponibilidad

                    // Registrar en log
                    await registrarLog({
                        Usuario: userName,
                        Modulo: 'AsignacionInventario',
                        Detalle: `Item desasignado: ${item.Codigo_Individual || 'sin código'} (${item.Nombre_Producto}) de trabajador ${trabajadorSeleccionado.Nombres} ${trabajadorSeleccionado.Apellidos}. Nuevo estado: ${formValues.estado}${formValues.razon ? '. Razón: ' + formValues.razon : ''}`,
                        Estado: 'Éxito',
                    });

                    Swal.fire('Éxito', `Item ${item.Codigo_Individual || 'sin código'} desasignado correctamente`, 'success');
                } else {
                    Swal.fire('Error', response.data.message || 'Error al desasignar el item', 'error');
                }
            } catch (error) {
                console.error("Error al desasignar item:", error);

                // Registrar error en log
                await registrarLog({
                    Usuario: userName,
                    Modulo: 'AsignacionInventario',
                    Detalle: `Error al desasignar item ${item.Codigo_Individual || 'sin código'} - ${error.message}`,
                    Estado: 'Error',
                });

                Swal.fire('Error', 'Error al desasignar el item', 'error');
            }
        }
    };

    // Función para exportar asignaciones a múltiples trabajadores
    const exportarAsignaciones = async () => {
        if (trabajadoresParaExportar.length === 0) {
            Swal.fire('Advertencia', 'Debe seleccionar al menos un trabajador', 'warning');
            return;
        }

        if (itemsParaExportar.length === 0) {
            Swal.fire('Advertencia', 'No hay items asignados para exportar', 'warning');
            return;
        }

        try {
            // Verificar conflictos antes de exportar
            const response = await Axios.post(`${config.API_URL}/verificarConflictosExportacion`, {
                trabajadoresDestino: trabajadoresParaExportar,
                itemsAsignados: itemsParaExportar.map(item => ({
                    ID_Producto: item.ID_Producto,
                    ID_Tipo: item.ID_Tipo,
                    Nombre_Producto: item.Nombre_Producto,
                    Nombre_Tipo: item.Nombre_Tipo,
                    talla: item.Talla,
                    color: item.Color
                }))
            });

            if (response.data.conflictos && response.data.conflictos.length > 0) {
                // Mostrar alerta con los conflictos encontrados
                const conflictosHtml = response.data.conflictos.map(conflicto => {
                    const trabajador = trabajadores.find(t => t.ID_Trabajador === conflicto.idTrabajador);
                    return `<li><strong>${trabajador?.Nombres} ${trabajador?.Apellidos}</strong>: Ya tiene ${conflicto.tiposConflicto.join(', ')}</li>`;
                }).join('');

                const { isConfirmed } = await Swal.fire({
                    title: 'Conflictos Detectados',
                    html: `
                        <div style="text-align: left;">
                            <p>Los siguientes trabajadores ya tienen items de los mismos tipos que se intentan asignar:</p>
                            <ul style="margin: 10px 0;">${conflictosHtml}</ul>
                            <p><strong>¿Desea continuar con la exportación de todas formas?</strong></p>
                        </div>
                    `,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Continuar de todas formas',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#f39c12'
                });

                if (!isConfirmed) {
                    return;
                }
            }

            // Proceder con la exportación
            const exportResponse = await Axios.post(`${config.API_URL}/exportarAsignaciones`, {
                trabajadoresDestino: trabajadoresParaExportar,
                itemsAsignados: itemsParaExportar.map(item => ({
                    ID_Producto: item.ID_Producto,
                    talla: item.Talla,
                    color: item.Color
                })),
                usuarioAsignacion: userName
            });

            if (exportResponse.data.success) {
                Swal.fire('Éxito', `Asignaciones exportadas a ${trabajadoresParaExportar.length} trabajadores`, 'success');
                setShowExportModal(false);
                setTrabajadoresParaExportar([]);
                setItemsParaExportar([]);
                await cargarDetalleInventario();
            }
        } catch (error) {
            console.error("Error al exportar asignaciones:", error);
            Swal.fire('Error', 'Error al exportar las asignaciones', 'error');
        }
    };

    // Función para abrir modal de selección de items para PDF
    const abrirModalSeleccionPDF = () => {
        if (!trabajadorSeleccionado || itemsAsignados.length === 0) {
            Swal.fire('Advertencia', 'Debe seleccionar un trabajador y tener items asignados', 'warning');
            return;
        }

        console.log('Items asignados al abrir modal:', itemsAsignados);
        console.log('Primer item estructura:', itemsAsignados[0]);

        // Inicializar todos los items como seleccionados por defecto
        const itemsIniciales = [...itemsAsignados];
        console.log('Items iniciales para PDF:', itemsIniciales);
        setItemsSeleccionadosPDF(itemsIniciales);
        setShowSeleccionPDFModal(true);
    };

    // Función para manejar selección/deselección de items
    const toggleItemSeleccionado = (item) => {
        console.log('Toggle item:', item.ID_Detalle);
        console.log('Items seleccionados antes:', itemsSeleccionadosPDF.map(i => i.ID_Detalle));

        setItemsSeleccionadosPDF(prev => {
            const isSelected = prev.some(selected =>
                selected.ID_Detalle === item.ID_Detalle
            );

            console.log('¿Está seleccionado?', isSelected);

            if (isSelected) {
                // Remover item
                const newArray = prev.filter(selected =>
                    selected.ID_Detalle !== item.ID_Detalle
                );
                console.log('Removiendo, nuevo array:', newArray.map(i => i.ID_Detalle));
                return newArray;
            } else {
                // Agregar item
                const newArray = [...prev, item];
                console.log('Agregando, nuevo array:', newArray.map(i => i.ID_Detalle));
                return newArray;
            }
        });
    };

    // Función para generar PDF con items seleccionados
    const generarPDFConItemsSeleccionados = async () => {
        // Para plantillas en blanco, no se requiere validación de items
        if (tipoActa !== "blanco" && itemsSeleccionadosPDF.length === 0) {
            Swal.fire('Advertencia', 'Debe seleccionar al menos un item para incluir en el PDF', 'warning');
            return;
        }

        setShowSeleccionPDFModal(false);

        // Para plantillas en blanco, pasamos array vacío
        const itemsParaPDF = tipoActa === "blanco" ? [] : itemsSeleccionadosPDF;
        await generarPDFEntrega(itemsParaPDF);
    };

    // Función para generar PDF de entrega de EPP
    const generarPDFEntrega = async (itemsParaPDF = itemsAsignados) => {
        // Para plantillas en blanco, no validamos trabajador ni items
        if (tipoActa !== "blanco" && (!trabajadorSeleccionado || itemsParaPDF.length === 0)) {
            Swal.fire('Advertencia', 'Debe seleccionar un trabajador y tener items para el PDF', 'warning');
            return;
        }

        try {
            const doc = new jsPDF();

            const empresaActual = lookupEmpresa(idEmpresa) || lookupEmpresa(cookies.selectedCard);

            if (!empresaActual) {
                Swal.fire('Error', 'No se pudo determinar la información de la empresa', 'error');
                return;
            }

            // Configurar márgenes y colores en blanco y negro
            const pageWidth = doc.internal.pageSize.width;
            const pageHeight = doc.internal.pageSize.height;
            const margin = 12;
            const blackColor = [0, 0, 0];
            const grayColor = [128, 128, 128];

            // HEADER SECTION
            // Agregar logo de la empresa con proporción correcta
            try {
                const logoImg = new Image();
                logoImg.crossOrigin = "anonymous";

                await new Promise((resolve, reject) => {
                    logoImg.onload = () => {
                        try {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            canvas.width = logoImg.width;
                            canvas.height = logoImg.height;
                            ctx.drawImage(logoImg, 0, 0);
                            const logoBase64 = canvas.toDataURL('image/png');

                            // Calcular proporciones correctas del logo
                            const logoWidth = 25;
                            const logoHeight = (logoImg.height / logoImg.width) * logoWidth;

                            doc.addImage(logoBase64, 'PNG', margin, 8, logoWidth, logoHeight);
                            resolve();
                        } catch (err) {
                            console.warn('Error al procesar logo:', err);
                            resolve();
                        }
                    };
                    logoImg.onerror = () => {
                        console.warn('No se pudo cargar el logo:', empresaActual.logoPDF);
                        resolve();
                    };
                    logoImg.src = empresaActual.logoPDF;
                });
            } catch (error) {
                console.warn('Error al cargar logo:', error);
            }

            // Header con borde superior simple
            doc.setDrawColor(...blackColor);
            doc.setLineWidth(1);
            doc.line(margin, 5, pageWidth - margin, 5);

            // Información del documento en header derecho
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(9);
            doc.setTextColor(...blackColor);

            doc.text(`N°_____ `, pageWidth - margin, 10, { align: 'right' });

            // TÍTULO PRINCIPAL - dinámico según tipo de acta
            let yPos = 28;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(13);
            doc.setTextColor(...blackColor);

            if (tipoActa === "reposicion") {
                doc.text('ACTA DE REPOSICION DE ELEMENTOS', pageWidth / 2, yPos, { align: 'center' });
            } else {
                doc.text('ACTA DE ENTREGA DE ELEMENTOS', pageWidth / 2, yPos, { align: 'center' });
            }
            yPos += 5;
            doc.text('DE PROTECCIÓN PERSONAL', pageWidth / 2, yPos, { align: 'center' });

            // Línea decorativa bajo el título
            yPos += 6;
            doc.setDrawColor(...blackColor);
            doc.setLineWidth(0.5);
            doc.line(margin + 25, yPos, pageWidth - margin - 25, yPos);

            // INFORMACIÓN DEL TRABAJADOR - dinámico según tipo de acta
            yPos += 10;

            let trabajadorData;
            if (tipoActa === "blanco") {
                // Para plantilla en blanco, dejar campos vacíos
                trabajadorData = [
                    ['NOMBRE COMPLETO', ''],
                    ['RUT', ''],
                    ['FECHA', '']
                ];
            } else {
                // Para actas con datos del trabajador seleccionado
                trabajadorData = [
                    ['NOMBRE COMPLETO', `${trabajadorSeleccionado.Nombres} ${trabajadorSeleccionado.Apellidos}`],
                    ['RUT', formatearRutCompleto(trabajadorSeleccionado.Rut)],
                    ['FECHA', new Date().toLocaleDateString('es-CL')]
                ];
            }

            doc.autoTable({
                startY: yPos,
                head: [['INFORMACIÓN DEL TRABAJADOR', '']],
                body: trabajadorData,
                theme: 'grid',
                headStyles: {
                    fillColor: [220, 220, 220], // Gris claro en lugar de color
                    textColor: [0, 0, 0],
                    fontSize: 9,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                bodyStyles: {
                    fontSize: 8,
                    cellPadding: 2
                },
                columnStyles: {
                    0: { cellWidth: 35, fontStyle: 'bold', fillColor: [245, 245, 245] },
                    1: { cellWidth: 'auto' }
                },
                margin: { left: margin, right: margin },
                didDrawPage: function (data) {
                    yPos = data.cursor.y;
                }
            });

            // TABLA DE ELEMENTOS ENTREGADOS - más compacta
            yPos += 6;

            // Preparar datos de la tabla de elementos
            const elementosData = [];
            const fechaHoy = new Date().toLocaleDateString('es-CL');

            if (tipoActa === "blanco") {
                // Para plantilla en blanco, crear 15 filas vacías
                for (let i = 0; i < 15; i++) {
                    elementosData.push([
                        (i + 1).toString(),
                        '',
                        '',
                        '',
                        ''
                    ]);
                }
            } else {
                // Para actas con datos, agregar items seleccionados para el PDF
                itemsParaPDF.forEach((item, index) => {
                    const descripcion = `${item.Nombre_Producto}${item.Talla ? ` - Talla ${item.Talla}` : ''}${item.Color ? ` - ${item.Color}` : ''}`;
                    elementosData.push([
                        (index + 1).toString(),
                        '1',
                        descripcion,
                        fechaHoy,
                        '' // Columna para firma
                    ]);
                });

                // Si hay menos de 10 items, completar con filas vacías
                const minFilas = Math.max(10, itemsParaPDF.length);
                for (let i = itemsParaPDF.length; i < minFilas; i++) {
                    elementosData.push([
                        (i + 1).toString(),
                        '',
                        '',
                        '',
                        ''
                    ]);
                }
            }

            doc.autoTable({
                startY: yPos,
                head: [['N°', 'CANT.', 'DESCRIPCIÓN DEL ELEMENTO', 'FECHA', 'FIRMA']],
                body: elementosData,
                theme: 'grid',
                headStyles: {
                    fillColor: [220, 220, 220], // Gris claro
                    textColor: [0, 0, 0],
                    fontSize: 8,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                bodyStyles: {
                    fontSize: 7,
                    cellPadding: 2,
                    valign: 'middle',
                    halign: 'center' // Centrar todo el contenido de las celdas
                },
                columnStyles: {
                    0: { cellWidth: 12, halign: 'center' },
                    1: { cellWidth: 16, halign: 'center' },
                    2: { cellWidth: 75, halign: 'center' }, // Centrar también la descripción
                    3: { cellWidth: 20, halign: 'center' },
                    4: { cellWidth: 25, halign: 'center' }
                },
                // Centrar la tabla completa en la página
                margin: {
                    left: (pageWidth - 148) / 2, // 148 es la suma de todos los cellWidth
                    right: (pageWidth - 148) / 2
                },
                didDrawPage: function (data) {
                    yPos = data.cursor.y;
                }
            });

            // SECCIÓN DE FIRMAS - más compacta
            yPos += 4;

            doc.autoTable({
                startY: yPos,
                head: [['FIRMAS Y CONFORMIDAD', '']],
                body: [
                    ['TRABAJADOR QUE RECIBE', 'RESPONSABLE QUE ENTREGA'],
                    ['', ''],
                    ['Nombre y Firma', 'Nombre y Firma']
                ],
                theme: 'grid',
                headStyles: {
                    fillColor: [220, 220, 220], // Gris claro
                    textColor: [0, 0, 0],
                    fontSize: 9,
                    fontStyle: 'bold',
                    halign: 'center'
                },
                bodyStyles: {
                    fontSize: 8,
                    cellPadding: 6,
                    halign: 'center'
                },
                columnStyles: {
                    0: { cellWidth: (pageWidth - 2 * margin) / 2 },
                    1: { cellWidth: (pageWidth - 2 * margin) / 2 }
                },
                margin: { left: margin, right: margin },
                didDrawPage: function (data) {
                    yPos = data.cursor.y;
                }
            });

            // TEXTO LEGAL - más compacto
            yPos += 4;

            // Título para condiciones
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.setTextColor(...blackColor);
            doc.text('CONDICIONES Y RESPONSABILIDADES:', margin, yPos);

            yPos += 3;
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(7);
            doc.setTextColor(...blackColor);

            // Texto legal muy compactado
            const textoLegal = [
                `• Art. 54.- El trabajador debe usar adecuadamente los EPP entregados por ${empresaActual.nombre}.`,
                `• Los EPP son propiedad de ${empresaActual.nombre} y deben ser cuidados apropiadamente.`,
                '• Para solicitar nuevos elementos, debe canjear o devolver los que tenga en su poder.',
                '• Debe presentarse en su puesto debidamente equipado antes del inicio de la jornada laboral.'
            ];

            textoLegal.forEach((texto, index) => {
                const lines = doc.splitTextToSize(texto, pageWidth - 2 * margin);
                lines.forEach((line, lineIndex) => {
                    doc.text(line, margin, yPos + (index * 6) + (lineIndex * 2.5));
                });
            });

            // FOOTER simple
            const footerY = pageHeight - 10;
            doc.setDrawColor(...blackColor);
            doc.setLineWidth(0.5);
            doc.line(margin, footerY, pageWidth - margin, footerY);

            doc.setFont('helvetica', 'italic');
            doc.setFontSize(7);
            doc.setTextColor(...grayColor);
            doc.text(`${empresaActual.nombre} - Documento generado automáticamente`, pageWidth / 2, footerY + 3, { align: 'center' });

            // Guardar PDF con nombre dinámico según tipo de acta
            let nombreArchivo;
            if (tipoActa === "blanco") {
                const fechaActual = new Date().toLocaleDateString('es-CL').replace(/\//g, '-');
                nombreArchivo = `Plantilla_EPP_${tipoActa === "reposicion" ? "Reposicion" : "Entrega"}_${fechaActual}.pdf`;
            } else {
                nombreArchivo = `${tipoActa === "reposicion" ? "Reposicion" : "Entrega"}_EPP_${trabajadorSeleccionado.Nombres}_${trabajadorSeleccionado.Apellidos}_${new Date().toLocaleDateString('es-CL').replace(/\//g, '-')}.pdf`;
            }
            doc.save(nombreArchivo);

            Swal.fire('Éxito', 'PDF generado correctamente', 'success');

        } catch (error) {
            console.error('Error al generar PDF:', error);
            Swal.fire('Error', 'Error al generar el PDF', 'error');
        }
    };

    // Obtener icono para cada tipo de producto
    const getIconoTipo = (nombreTipo) => {
        const iconos = {
            'Cascos': 'fas fa-hard-hat',
            'CascosSeguridad': 'fas fa-hard-hat',
            'Guantes': 'fas fa-hand-paper',
            'Zapatos': 'fas fa-shoe-prints',
            'ZapatosSeguridad': 'fas fa-shoe-prints',
            'Chalecos': 'fas fa-vest',
            'Overoles': 'fas fa-tshirt',
            'Lentes': 'fas fa-glasses',
            'LentesSeguridad': 'fas fa-glasses',
            'Mascarillas': 'fas fa-head-side-mask',
            'Respiradores': 'fas fa-head-side-mask',
            'default': 'fas fa-box'
        };

        const nombreLimpio = nombreTipo.replace(/\s+/g, '');
        return iconos[nombreLimpio] || iconos[nombreTipo] || iconos.default;
    };

    return (
        <div id="wrapper">
            <Sidebar
                imageUrl={imageUrl}
                isComponentsCollapsed={isComponentsCollapsed}
                toggleCollapse={toggleCollapse}
                setIsComponentsCollapsed={setIsComponentsCollapsed}
                isUtilitiesCollapsed={isUtilitiesCollapsed}
                setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                isContabilidadCollapsed={isContabilidadCollapsed}
                setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                isInventario={isInventario}
                setisIventatioCollapsed={setisIventatioCollapsed}
                isPrevencion={isPrevencion}
                setisPrevencionCollapsed={setisPrevencionCollapsed}
                isLogistica={isLogistica}
                setisLogisticaCollapsed={setisLogisticaCollapsed}
                cookies={cookies}
            />

            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">

                    <div className="container-fluid">
                        <div className="d-sm-flex align-items-center justify-content-between mb-4">
                            <h1 className="h3 mb-0 text-gray-800">
                                <i className="fas fa-user-hard-hat"></i> Asignación de Inventario
                            </h1>
                        </div>

                        <div className="row">
                            <div className={trabajadorSeleccionado ? "col-lg-8" : "col-12"}>
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="m-0 font-weight-bold text-primary">
                                                {vistaActual === "trabajadores" && "Seleccionar Trabajador"}
                                                {vistaActual === "tipos" && `Catálogo de Inventario - ${trabajadorSeleccionado?.Nombres} ${trabajadorSeleccionado?.Apellidos}`}
                                                {vistaActual === "productos" && `Productos - ${tipoSeleccionado?.Nombre_Tipo}`}
                                                {vistaActual === "items" && `Items Disponibles - ${productoSeleccionado?.Nombre_Producto}`}
                                            </h6>

                                            {/* Breadcrumb de navegación */}
                                            {vistaActual !== "trabajadores" && (
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb mb-0">
                                                        <li className="breadcrumb-item">
                                                            <button
                                                                className="btn btn-link p-0 text-decoration-none"
                                                                onClick={() => volverAVista("trabajadores")}
                                                            >
                                                                <i className="fas fa-users"></i> Trabajadores
                                                            </button>
                                                        </li>
                                                        {vistaActual !== "tipos" && (
                                                            <li className="breadcrumb-item">
                                                                <button
                                                                    className="btn btn-link p-0 text-decoration-none"
                                                                    onClick={() => volverAVista("tipos")}
                                                                >
                                                                    <i className="fas fa-boxes"></i> Catálogo
                                                                </button>
                                                            </li>
                                                        )}
                                                        {vistaActual === "items" && (
                                                            <li className="breadcrumb-item">
                                                                <button
                                                                    className="btn btn-link p-0 text-decoration-none"
                                                                    onClick={() => volverAVista("productos")}
                                                                >
                                                                    <i className="fas fa-box"></i> Productos
                                                                </button>
                                                            </li>
                                                        )}
                                                        <li className="breadcrumb-item active" aria-current="page">
                                                            {vistaActual === "tipos" && "Tipos"}
                                                            {vistaActual === "productos" && tipoSeleccionado?.Nombre_Tipo}
                                                            {vistaActual === "items" && productoSeleccionado?.Nombre_Producto}
                                                        </li>
                                                    </ol>
                                                </nav>
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        {/* Vista: Lista de Trabajadores */}
                                        {vistaActual === "trabajadores" && !showExportModal && (
                                            <div className="row">
                                                {trabajadores.map((trabajador) => (
                                                    <div key={trabajador.ID_Trabajador} className="col-md-4 col-lg-3 mb-4">
                                                        <div
                                                            className="card h-100 shadow-sm hover-shadow"
                                                            style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                                                            onClick={() => seleccionarTrabajador(trabajador)}
                                                        >
                                                            <div className="card-body text-center">
                                                                <div className="mb-3">
                                                                    <i className="fas fa-user fa-3x text-primary"></i>
                                                                </div>
                                                                <h6 className="card-title">{trabajador.Nombres} {trabajador.Apellidos}</h6>
                                                                <p className="card-text text-muted small">
                                                                    <strong>RUT:</strong> {formatearRutCompleto(trabajador.Rut)}<br />
                                                                </p>
                                                                <div className="d-flex justify-content-center">
                                                                    <span className="badge badge-success">
                                                                        <i className="fas fa-check-circle"></i> Activo
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        {/* Vista: Lista de Trabajadores (Placeholder cuando modal está abierto) */}
                                        {vistaActual === "trabajadores" && showExportModal && (
                                            <div className="row">
                                                <div className="col-12 text-center py-5">
                                                    <div className="text-muted">
                                                        <i className="fas fa-copy fa-3x mb-3"></i>
                                                        <h5>Exportando asignaciones...</h5>
                                                        <p>Seleccione los trabajadores destino en el modal.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Vista: Tipos de Producto */}
                                        {vistaActual === "tipos" && (
                                            <div className="row">
                                                {tiposProducto.map((tipo) => {
                                                    const productosDelTipo = getProductosPorTipo(tipo.ID_Tipo);
                                                    const itemsDisponibles = productosDelTipo.reduce((total, producto) => {
                                                        return total + getItemsDisponiblesPorProducto(producto.ID_Producto).length;
                                                    }, 0);

                                                    return (
                                                        <div key={tipo.ID_Tipo} className="col-md-4 col-lg-3 mb-4">
                                                            <div
                                                                className="card h-100 shadow-sm hover-shadow"
                                                                style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                                                                onClick={() => navegarATipo(tipo)}
                                                            >
                                                                <div className="card-body text-center">
                                                                    <div className="mb-3">
                                                                        <i
                                                                            className={`${getIconoTipo(tipo.Nombre_Tipo)} fa-3x text-primary`}
                                                                        ></i>
                                                                    </div>
                                                                    <h6 className="card-title">{tipo.Nombre_Tipo}</h6>
                                                                    <p className="card-text text-muted small">
                                                                        {productosDelTipo.length} productos
                                                                    </p>
                                                                    <div className="text-success">
                                                                        <strong>{itemsDisponibles}</strong> disponibles
                                                                    </div>
                                                                    {tipo.Es_EPP === 'Si' && (
                                                                        <span className="badge badge-warning mt-2">
                                                                            <i className="fas fa-shield-alt"></i> EPP
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {/* Vista: Productos del tipo seleccionado */}
                                        {vistaActual === "productos" && tipoSeleccionado && (
                                            <div className="row">
                                                {getProductosPorTipo(tipoSeleccionado.ID_Tipo).map((producto) => {
                                                    const itemsDisponibles = getItemsDisponiblesPorProducto(producto.ID_Producto);

                                                    return (
                                                        <div key={producto.ID_Producto} className="col-md-6 col-lg-4 mb-4">
                                                            <div
                                                                className="card h-100 shadow-sm hover-shadow"
                                                                style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                                                                onClick={() => navegarAProducto(producto)}
                                                            >
                                                                <div className="card-body">
                                                                    <h6 className="card-title">{producto.Nombre_Producto}</h6>
                                                                    <p className="text-muted small mb-2">
                                                                        <strong>Código:</strong> {producto.Codigo_Producto}
                                                                    </p>
                                                                    <p className="text-muted small mb-3">
                                                                        <strong>Marca:</strong> {producto.Marca || 'Sin marca'}
                                                                    </p>

                                                                    <div className="text-center">
                                                                        <div className="text-success">
                                                                            <i className="fas fa-check-circle"></i>
                                                                            <div className="font-weight-bold">{itemsDisponibles.length}</div>
                                                                            <small>Disponibles</small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {/* Vista: Items disponibles para asignación */}
                                        {vistaActual === "items" && productoSeleccionado && (
                                            <div>
                                                <div className="mb-3">
                                                    <p className="text-muted">Arrastra los items hacia el trabajador para asignarlos</p>
                                                </div>

                                                <div className="row">
                                                    {getItemsDisponiblesPorProducto(productoSeleccionado.ID_Producto).map((item) => (
                                                        <div key={item.ID_Detalle} className="col-md-6 col-lg-4 mb-3">
                                                            <div
                                                                className="card shadow-sm hover-shadow item-arrastrable"
                                                                style={{ cursor: 'grab', transition: 'all 0.3s' }}
                                                                draggable
                                                                onDragStart={(e) => {
                                                                    e.dataTransfer.setData('item', JSON.stringify(item));
                                                                }}
                                                                onClick={() => asignarItem(item)}
                                                            >
                                                                <div className="card-body p-3">
                                                                    <div className="d-flex justify-content-between align-items-start">
                                                                        <div>
                                                                            <h6 className="card-title mb-1">
                                                                                <code className="text-primary">{item.Codigo_Individual}</code>
                                                                            </h6>
                                                                            <p className="card-text small mb-1">
                                                                                {item.Talla && <span className="badge badge-secondary mr-1">{item.Talla}</span>}
                                                                                {item.Color && <span className="badge badge-info">{item.Color}</span>}
                                                                            </p>
                                                                        </div>
                                                                        <i className="fas fa-plus-circle text-success"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                {getItemsDisponiblesPorProducto(productoSeleccionado.ID_Producto).length === 0 && (
                                                    <div className="text-center text-muted py-4">
                                                        <i className="fas fa-inbox fa-3x mb-3"></i>
                                                        <p>No hay items disponibles para este producto</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Panel del trabajador seleccionado */}
                            {trabajadorSeleccionado && (
                                <div className="col-lg-4">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3">
                                            <h6 className="m-0 font-weight-bold text-primary">
                                                <i className="fas fa-user"></i> {trabajadorSeleccionado.Nombres} {trabajadorSeleccionado.Apellidos}
                                            </h6>
                                        </div>
                                        <div
                                            className="card-body text-center zona-drop"
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                const item = JSON.parse(e.dataTransfer.getData('item'));
                                                asignarItem(item);
                                            }}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{ minHeight: '200px', backgroundColor: '#f8f9fc', border: '2px dashed #d1d3e2' }}
                                        >
                                            <div className="mb-4">
                                                <i className="fas fa-user fa-5x text-primary"></i>
                                            </div>

                                            <p className="text-muted mb-3">
                                                <strong>RUT:</strong> {formatearRutCompleto(trabajadorSeleccionado.Rut)}<br />
                                            </p>

                                            <div className="mb-3">
                                                <h6
                                                    className="text-primary"
                                                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                    onClick={handleItemsAsignadosClick}
                                                    title="Click para ver detalle completo"
                                                >
                                                    Items Asignados ({itemsAsignados.length})
                                                    <i className="fas fa-eye ml-1"></i>
                                                </h6>
                                            </div>

                                            {/* Lista de items asignados */}
                                            <div className="text-left" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                {itemsAsignados.map((item) => (
                                                    <div key={item.ID_Detalle} className="d-flex justify-content-between align-items-center mb-2 p-2 bg-light rounded">
                                                        <div>
                                                            <small>
                                                                <strong>{item.Nombre_Producto}</strong><br />
                                                                <code>{item.Codigo_Individual}</code>
                                                                {item.Talla && <span className="badge badge-secondary badge-sm ml-1">{item.Talla}</span>}
                                                                {item.Color && <span className="badge badge-info badge-sm ml-1">{item.Color}</span>}
                                                            </small>
                                                        </div>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => desasignarItem(item)}
                                                            title="Desasignar item"
                                                        >
                                                            <i className="fas fa-times"></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>

                                            {itemsAsignados.length === 0 && (
                                                <p className="text-muted small">Arrastra items aquí para asignar</p>
                                            )}

                                            {/* Botones de acción */}
                                            {itemsAsignados.length > 0 && (
                                                <div className="mt-3">
                                                    <button
                                                        className="btn btn-success btn-sm mr-2"
                                                        onClick={() => {
                                                            Swal.fire('Éxito', 'Asignación completada', 'success');
                                                            volverAVista("trabajadores");
                                                        }}
                                                    >
                                                        <i className="fas fa-check"></i> Terminar Asignación
                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm mr-2"
                                                        onClick={abrirModalSeleccionPDF}
                                                        title="Generar PDF de entrega"
                                                    >
                                                        <i className="fas fa-file-pdf"></i> Generar PDF
                                                    </button>
                                                    <button
                                                        className="btn btn-info btn-sm"
                                                        onClick={() => {
                                                            setItemsParaExportar([...itemsAsignados]); // Capturar items actuales
                                                            setShowExportModal(true);
                                                        }}
                                                    >
                                                        <i className="fas fa-copy"></i> Exportar
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal para exportar asignaciones */}
            {showExportModal && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div
                        className="modal-dialog modal-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            className="modal-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-copy"></i> Exportar Asignaciones
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => {
                                        setShowExportModal(false);
                                        setTrabajadoresParaExportar([]);
                                        setItemsParaExportar([]);
                                    }}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="text-muted mb-3">
                                    Selecciona los trabajadores que recibirán la misma asignación que <strong>{trabajadorSeleccionado?.Nombres} {trabajadorSeleccionado?.Apellidos}</strong>
                                </p>

                                <div className="row">
                                    {trabajadores
                                        .filter(t => t.ID_Trabajador !== trabajadorSeleccionado?.ID_Trabajador)
                                        .map((trabajador) => (
                                            <div key={trabajador.ID_Trabajador} className="col-md-6 mb-2">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`trabajador_${trabajador.ID_Trabajador}`}
                                                        checked={trabajadoresParaExportar.includes(trabajador.ID_Trabajador)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setTrabajadoresParaExportar(prev => [...prev, trabajador.ID_Trabajador]);
                                                            } else {
                                                                setTrabajadoresParaExportar(prev => prev.filter(id => id !== trabajador.ID_Trabajador));
                                                            }
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor={`trabajador_${trabajador.ID_Trabajador}`}>
                                                        {trabajador.Nombres} {trabajador.Apellidos} - {formatearRutCompleto(trabajador.Rut)}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowExportModal(false);
                                        setTrabajadoresParaExportar([]);
                                        setItemsParaExportar([]);
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={exportarAsignaciones}
                                    disabled={trabajadoresParaExportar.length === 0}
                                >
                                    <i className="fas fa-copy"></i> Exportar a {trabajadoresParaExportar.length} trabajador(es)
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de detalle de items asignados */}
            {showDetalleModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-list-ul mr-2"></i>
                                    Detalle Completo de Items Asignados
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowDetalleModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {loadingDetalle ? (
                                    <div className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                        <p className="mt-2">Cargando detalle de items...</p>
                                    </div>
                                ) : (
                                    <>
                                        {trabajadorSeleccionado && (
                                            <div className="card mb-4">
                                                <div className="card-header bg-primary text-white">
                                                    <h6 className="mb-0">
                                                        <i className="fas fa-user mr-2"></i>
                                                        Información del Trabajador
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <strong>Nombre:</strong> {trabajadorSeleccionado.Nombres} {trabajadorSeleccionado.Apellidos}
                                                        </div>
                                                        <div className="col-md-4">
                                                            <strong>RUT:</strong> {formatearRutCompleto(trabajadorSeleccionado.Rut)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="card">
                                            <div className="card-header bg-info text-white">
                                                <h6 className="mb-0">
                                                    <i className="fas fa-box mr-2"></i>
                                                    Items Asignados ({itemsAsignadosDetalle.length})
                                                </h6>
                                            </div>
                                            <div className="card-body p-0">
                                                {itemsAsignadosDetalle.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <table className="table table-hover mb-0">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>Código</th>
                                                                    <th>Producto</th>
                                                                    <th>Tipo</th>
                                                                    <th>Marca</th>
                                                                    <th>Talla</th>
                                                                    <th>Color</th>
                                                                    <th>Fecha Asignación</th>
                                                                    <th>Usuario Registro</th>
                                                                    <th>Observaciones</th>
                                                                    <th>EPP</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {itemsAsignadosDetalle.map((item, index) => (
                                                                    <tr key={item.ID_Detalle}>
                                                                        <td>
                                                                            <code className="small">
                                                                                {item.Codigo_Individual || item.Codigo_Producto}
                                                                            </code>
                                                                        </td>
                                                                        <td>
                                                                            <strong>{item.Nombre_Producto}</strong>
                                                                        </td>
                                                                        <td>
                                                                            <span className="badge badge-secondary">
                                                                                {item.Nombre_Tipo}
                                                                            </span>
                                                                        </td>
                                                                        <td>{item.Marca || 'N/A'}</td>
                                                                        <td>
                                                                            {item.Talla ? (
                                                                                <span className="badge badge-info">
                                                                                    {item.Talla}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="text-muted">N/A</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            {item.Color ? (
                                                                                <span className="badge badge-dark">
                                                                                    {item.Color}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="text-muted">N/A</span>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <small>
                                                                                {item.Fecha_Asignacion ?
                                                                                    new Date(item.Fecha_Asignacion).toLocaleDateString('es-CL') :
                                                                                    'N/A'
                                                                                }
                                                                            </small>
                                                                        </td>
                                                                        <td>
                                                                            <small className="text-muted">
                                                                                {item.Usuario_Registro}
                                                                            </small>
                                                                        </td>
                                                                        <td>
                                                                            <small>
                                                                                {item.Observaciones || 'Sin observaciones'}
                                                                            </small>
                                                                        </td>
                                                                        <td>
                                                                            {item.Es_EPP === 'Si' ? (
                                                                                <span className="badge badge-success">
                                                                                    <i className="fas fa-hard-hat mr-1"></i>EPP
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge badge-light">
                                                                                    <i className="fas fa-tools mr-1"></i>Otro
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                                        <p className="text-muted">No hay items asignados para mostrar</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <div className="text-muted small mr-auto">
                                    <i className="fas fa-info-circle mr-1"></i>
                                    Total de items: {itemsAsignadosDetalle.length}
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowDetalleModal(false)}
                                >
                                    <i className="fas fa-times mr-1"></i>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de selección de items para PDF */}
            {showSeleccionPDFModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content" style={{ maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="fas fa-file-pdf mr-2 text-danger"></i>
                                    Seleccionar Items para PDF
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowSeleccionPDFModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'auto', flex: '1' }}>
                                <div className="alert alert-info">
                                    <i className="fas fa-info-circle mr-2"></i>
                                    <strong>Selecciona los items que deseas incluir en el PDF.</strong><br />
                                    Esto no afecta los items realmente asignados al trabajador, solo determina qué aparecerá en el documento de entrega.
                                </div>

                                {/* Selector de tipo de acta */}
                                <div className="card mb-3">
                                    <div className="card-body">
                                        <h6 className="card-title">
                                            <i className="fas fa-file-contract mr-2"></i>
                                            Tipo de Acta
                                        </h6>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="tipoActa"
                                                id="actaEntrega"
                                                value="entrega"
                                                checked={tipoActa === "entrega"}
                                                onChange={(e) => setTipoActa(e.target.value)}
                                            />
                                            <label className="form-check-label" htmlFor="actaEntrega">
                                                <strong>Acta de Entrega</strong> - Para entrega inicial de EPP
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="tipoActa"
                                                id="actaReposicion"
                                                value="reposicion"
                                                checked={tipoActa === "reposicion"}
                                                onChange={(e) => setTipoActa(e.target.value)}
                                            />
                                            <label className="form-check-label" htmlFor="actaReposicion">
                                                <strong>Acta de Reposición</strong> - Para reemplazo de EPP existente
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="tipoActa"
                                                id="actaBlanco"
                                                value="blanco"
                                                checked={tipoActa === "blanco"}
                                                onChange={(e) => setTipoActa(e.target.value)}
                                            />
                                            <label className="form-check-label" htmlFor="actaBlanco">
                                                <strong>Plantilla en Blanco</strong> - Documento vacío para completar manualmente
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Aviso especial para plantilla en blanco */}
                                {tipoActa === "blanco" && (
                                    <div className="alert alert-warning">
                                        <i className="fas fa-exclamation-triangle mr-2"></i>
                                        <strong>Plantilla en Blanco Seleccionada</strong><br />
                                        Se generará un documento vacío con 15 filas en blanco para ser completado manualmente.
                                        No es necesario seleccionar items ya que el documento será completamente vacío.
                                    </div>
                                )}

                                {/* Solo mostrar selección de items si NO es plantilla en blanco */}
                                {tipoActa !== "blanco" && (
                                    <>
                                        <div className="mb-3">
                                            <h6 className="font-weight-bold mb-0">
                                                <i className="fas fa-list mr-2"></i>
                                                Items Disponibles ({itemsAsignados.length})
                                            </h6>
                                            <small className="text-muted">Haz clic en cada item para seleccionar/deseleccionar</small>
                                        </div>

                                        <div className="row">
                                            {itemsAsignados.map((item, index) => {
                                                console.log(`Item ${index}:`, item);
                                                console.log(`ID del item ${index}:`, item?.ID_Detalle);

                                                const isSelected = itemsSeleccionadosPDF.some(selected =>
                                                    selected?.ID_Detalle === item?.ID_Detalle
                                                );

                                                return (
                                                    <div key={item?.ID_Detalle || index} className="col-md-6 mb-2">
                                                        <div
                                                            className={`card cursor-pointer border ${isSelected ? 'border-success bg-light' : 'border-light'}`}
                                                            onClick={() => {
                                                                console.log('Click en item:', item);
                                                                toggleItemSeleccionado(item);
                                                            }}
                                                            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                                        >
                                                            <div className="card-body p-2">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="mr-2">
                                                                        <i className={`fas ${isSelected ? 'fa-check-circle text-success' : 'fa-circle text-muted'}`}></i>
                                                                    </div>
                                                                    <div className="flex-grow-1">
                                                                        <div className="font-weight-bold text-truncate" style={{ fontSize: '0.9rem' }}>
                                                                            {item.Nombre_Producto}
                                                                        </div>
                                                                        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                                            <span className="mr-2">
                                                                                <i className="fas fa-tag mr-1"></i>
                                                                                {item.Nombre_Tipo}
                                                                            </span>
                                                                            {item.Talla && (
                                                                                <span className="mr-2">
                                                                                    <i className="fas fa-expand-arrows-alt mr-1"></i>
                                                                                    {item.Talla}
                                                                                </span>
                                                                            )}
                                                                            {item.Color && (
                                                                                <span>
                                                                                    <i className="fas fa-palette mr-1"></i>
                                                                                    {item.Color}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        {itemsSeleccionadosPDF.length === 0 && (
                                            <div className="alert alert-warning text-center mt-3">
                                                <i className="fas fa-exclamation-triangle mr-2"></i>
                                                No has seleccionado ningún item. Debes seleccionar al menos uno para generar el PDF.
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                            <div className="modal-footer">
                                <div className="d-flex justify-content-between w-100 align-items-center">
                                    <div className="text-muted">
                                        {tipoActa === "blanco" ? (
                                            <>
                                                <i className="fas fa-file-alt mr-1"></i>
                                                Plantilla en blanco lista para generar
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-check-circle mr-1"></i>
                                                {itemsSeleccionadosPDF.length} de {itemsAsignados.length} items seleccionados
                                            </>
                                        )}
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-secondary mr-2"
                                            onClick={() => setShowSeleccionPDFModal(false)}
                                        >
                                            <i className="fas fa-times mr-1"></i>
                                            Cancelar
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={generarPDFConItemsSeleccionados}
                                            disabled={tipoActa !== "blanco" && itemsSeleccionadosPDF.length === 0}
                                        >
                                            <i className="fas fa-file-pdf mr-1"></i>
                                            {tipoActa === "blanco" ?
                                                "Generar Plantilla en Blanco" :
                                                `Generar PDF (${itemsSeleccionadosPDF.length})`
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AsignacionInventario;
